import { jwtDecode } from 'jwt-decode';
import { type Observable, BehaviorSubject, of } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs-operators';

export interface IAuth {
  token: string;
  refresh: string;
}

export class TokenService {
  private tokens$: BehaviorSubject<IAuth>;

  constructor() {
    this.tokens$ = new BehaviorSubject(null);
  }

  public getAccessToken(): Observable<string> {
    return this.tokens$.pipe(
      map(tokens => {
        return tokens?.token;
      }),
      distinctUntilChanged()
    );
  }

  public getTokens(): Observable<IAuth> {
    return this.tokens$.pipe(distinctUntilChanged());
  }

  public setTokens(tokens: IAuth | null) {
    if (!tokens) {
      window.sessionStorage.removeItem('refreshToken');
      this.tokens$.next(null);
      return of(null);
    }

    window.sessionStorage.setItem('refreshToken', tokens.refresh);
    this.tokens$.next(tokens);
    return of(tokens);
  }

  public clearToken() {
    return this.setTokens(null);
  }

  public decode<T>(token: string): T {
    try {
      return jwtDecode<T>(token);
    } catch (_err) {
      console.error('failed to decode token!');
      return null;
    }
  }
}

const tokenService = new TokenService();
export default tokenService;
